import React from 'react';

import Container from '../Container';

import Heading from '@components/Heading';

const CaseStudyHero = ({
  title = 'Title for this feature',
  subtitle,
  image = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/sq/hero.svg`,
  logo,
  // asBg,
}) => {
  return (
    <Container
      className={`fade fade-1 pt-16 lg:pt-24 max-w-screen-xl w-full items-center`}
    >
      <aside className={`max-w-xl mx-auto w-full`}>
        {logo && (
          <img
            src={logo}
            style={{ maxWidth: `200px` }}
            className="mb-4 lg:mb-8 mx-auto lg:mx-0"
          />
        )}
        <div className="text-center text-xl lg:text-xl lg:text-left mb-4 font-inter font-medium text-gray-500">
          Case Study
        </div>
        <Heading
          Tag="h1"
          size="sm"
          className="text-center lg:text-left max-w-lg"
        >
          {title}
        </Heading>
        {subtitle && (
          <h2 className="my-6 text-xl lg:text-2xl leading-normal font-medium font-inter text-gray-500 text-center lg:text-left lg:pr-16">
            {subtitle}
          </h2>
        )}
      </aside>
      <aside>
        <div className="relative z-0">
          <figure
            className={`relative mx-auto max-w-xl z-10 mt-12 lg:-mt-4 overflow-hidden`}
          >
            <div className="relative">
              <img
                src={image}
                style={{ minHeight: `200px` }}
                className="shadow-header fade rounded-lg"
              />
            </div>
          </figure>
        </div>
      </aside>
    </Container>
  );
};

export default CaseStudyHero;
